<script>
    import modalService from '@/services/core/modal.service';
    import Modal from '@/components/modals/Modal';
    import httpService from '@/services/core/http.service';
    import AdminGrid from '@/components/shared/AdminGrid';
    import { DxColumn } from 'devextreme-vue/data-grid';

    export default {
        props: {
            modalData: Object
        },
        components: {
            Modal,
            AdminGrid,
            DxColumn
        },
        data() {
            return {
                isLoading: 0,
                result: []
            };
        },
        methods: {
            close() {
                modalService.closeModal();
            },
            view(item) {
                window.open(`https://my.freshbooks.com/#/invoice/${item.accountId}-${item.id}`, '_blank');
            },
            getInvoices() {
                const freshbooksClientId = this.modalData.freshbooksClientId;

                const url = `company-billing-history/freshbooks-clients/invoices/${freshbooksClientId}`;

                this.isLoading++;

                httpService
                    .get(url)
                    .then(data => {
                        this.result = data;
                    })
                    .finally(() => this.isLoading--);
            }
        },
        mounted() {
            this.getInvoices();
        }
    };
</script>

<template>
    <Modal sizeClass="modal-lg">
        <form class="gsb-form" @submit.prevent="save">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title">Last freshbooks invoices</h3>
                </div>
                <div class="modal-body">
                    <div v-if="isLoading > 0">Searching...</div>
                    <AdminGrid
                        v-if="isLoading == 0"
                        :data-source="result"
                        :showActions="true"
                        :showFilters="false"
                        :showExport="false"
                        :showToolbar="false"
                        storage-key="resultGrid"
                    >
                        <DxColumn data-field="createdAt" />
                        <DxColumn data-field="invoiceNumber" />
                        <DxColumn data-field="paymentStatus" />
                        <DxColumn data-field="amount.amount" caption="Amount" data-type="currency" />
                        <template #actions="{ item }">
                            <button type="button" class="btn btn-link py-0 lh-1 text-primary" @click="view(item.data)">View</button>
                        </template>
                    </AdminGrid>
                </div>
                <div class="modal-footer d-flex justify-content-between">
                    <button type="button" class="btn" @click="close">Close</button>
                </div>
            </div>
        </form>
    </Modal>
</template>
